import * as yup from 'yup';

export const transactionCashRegisterSchema = yup.object({
  comment: yup.string(),
  cash: yup.number().required(),
  type: yup.string().required(),
});

export type schemaType = yup.InferType<typeof transactionCashRegisterSchema>;
